const locale = {
	SETTINGS: 'Настройки',
    WELCOME_BACK: 'Здравейте {{displayName}}, Добре дошли във Fix & Clean!',
    CLEAN_ROOMS: 'Почистени стаи',
    UNASSIGNED_ROOMS: 'Неназначени стаи',
    EXPRESS_ROOMS: 'Експресно почистване',
    CLEANING_ROOMS: 'В процес на почистване',
    CHECKOUT_ROOMS: 'Почистване при чекаут',
    MAINTENANCE_REQUESTS: 'Изчакващи заявки',
    EXPECTED_CHECK_INS: 'Очаквани настанявания',
    EXPECTED_CHECK_OUTS: 'Очаквани напускания',
    CANCELLATIONS: 'Анулирания',
    COMING_SOON: 'Очаквайте скоро',
    PMS_INTEGRATION_DATA: 'Данни от PMS интеграция',
};

export default locale;